<app-side-menu>
  <div class="movement-approvals-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="stockFilter" class="form-label">Filtrar por Estoque:</label>
          <select 
            id="stockFilter" 
            class="form-select" 
            [(ngModel)]="filters.stockId"
            (change)="applyFilters()">
            <option value="">Todos os estoques</option>
            <option *ngFor="let stock of stocks" [value]="stock.id">
              {{ stock.name }} ({{ stock.code }})
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="warehouseFilter" class="form-label">Filtrar por Almoxarifado:</label>
          <select 
            id="warehouseFilter" 
            class="form-select" 
            [(ngModel)]="filters.warehouseId"
            (change)="applyFilters()">
            <option value="">Todos os almoxarifados</option>
            <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
              {{ warehouse.name }} ({{ warehouse.code }})
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option value="">Todos os status</option>
            <option *ngFor="let status of statuses" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Estatísticas de Aprovações -->
    <div class="approvals-summary" *ngIf="!isLoading && movementApprovals.length > 0">
      <div class="summary-cards">
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-clock text-warning"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getPendingCount() }}</div>
            <div class="summary-label">Pendentes</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-check-circle text-success"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getApprovedCount() }}</div>
            <div class="summary-label">Aprovadas</div>
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-icon">
            <i class="fas fa-times-circle text-danger"></i>
          </div>
          <div class="summary-info">
            <div class="summary-number">{{ getRejectedCount() }}</div>
            <div class="summary-label">Rejeitadas</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Aprovações -->
    <div *ngIf="!isLoading && !error && filteredData.length > 0">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="filteredData"
        [loading]="isLoading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [totalItemsFromBackend]="totalItems"
        [itemsPerPage]="pageSize"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (actionClick)="onActionClick($event)">
        <app-button
          table-header-action
          text="Atualizar Aprovações"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="refresh-approvals-btn"
          (buttonClick)="retryLoad()">
        </app-button>
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!isLoading && !error && filteredData.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-clipboard-check"></i>
        <p>Nenhuma aprovação encontrada</p>
      </div>
    </div>

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <app-modal
      [isOpen]="showDecisionModal"
      [title]="decisionAction === 'approve' ? 'Aprovar movimentação' : 'Reprovar movimentação'"
      [size]="'md'"
      [closable]="true"
      (close)="closeDecisionModal()">
      <div class="py-2">
        <p class="text-muted mb-3">
          Informe a justificativa para
          <strong>{{ decisionAction === 'approve' ? 'aprovar' : 'reprovar' }}</strong>
          a movimentação <strong>#{{ selectedMovementId }}</strong>.
        </p>
        <label for="movementApprovalJustification" class="form-label">
          Justificativa <span class="text-danger">*</span>
        </label>
        <textarea
          id="movementApprovalJustification"
          class="form-control"
          rows="4"
          maxlength="500"
          [(ngModel)]="decisionJustification"
          placeholder="Digite a justificativa"></textarea>
      </div>
      <div slot="footer" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="closeDecisionModal()" [disabled]="isSubmittingDecision">
          Cancelar
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="decisionAction === 'approve' ? 'btn-success' : 'btn-danger'"
          (click)="confirmDecision()"
          [disabled]="!decisionJustification.trim() || isSubmittingDecision">
          <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmittingDecision"></i>
          Confirmar
        </button>
      </div>
    </app-modal>

    <app-modal
      [isOpen]="showViewModal"
      [title]="'Detalhes da aprovação'"
      [size]="'md'"
      [closable]="true"
      (close)="closeViewModal()">
      <div class="py-2" *ngIf="!isLoadingView && selectedApprovalDetail; else loadingApprovalDetailTpl">
        <div class="mb-2"><strong>ID da aprovação:</strong> {{ selectedApprovalDetail.id }}</div>
        <div class="mb-2"><strong>ID movimentação:</strong> #{{ selectedApprovalDetail.stockMovementId }}</div>
        <div class="mb-2"><strong>Status:</strong> {{ getApprovalStatusLabel(selectedApprovalDetail.status) }}</div>
        <div class="mb-2"><strong>Quantidade da movimentação:</strong> {{ selectedApprovalDetail.stockMovementQuantity ?? '—' }}</div>
        <div class="mb-2"><strong>Data da movimentação:</strong> {{ formatDateTime(selectedApprovalDetail.stockMovementDate) }}</div>
        <hr>
        <div class="mb-2"><strong>Solicitante:</strong> {{ selectedApprovalDetail.solicitanteNome || selectedApprovalDetail.createdBy || '—' }}</div>
        <div class="mb-2"><strong>Aprovador:</strong> {{ selectedApprovalDetail.aprovadorNome || selectedApprovalDetail.approverName || ('ID ' + selectedApprovalDetail.approverId) }}</div>
        <div class="mb-2"><strong>Aprovado/Reprovado por:</strong> {{ selectedApprovalDetail.approvedBy || selectedApprovalDetail.updatedBy || '—' }}</div>
        <div class="mb-2"><strong>Data da decisão:</strong> {{ formatDateTime(selectedApprovalDetail.approvedAt || selectedApprovalDetail.approvalDate) }}</div>
        <div class="mb-2"><strong>Criado em:</strong> {{ formatDateTime(selectedApprovalDetail.createdAt) }}</div>
        <div class="mb-2"><strong>Atualizado por:</strong> {{ selectedApprovalDetail.updatedBy || '—' }}</div>
        <div class="mb-2"><strong>Justificativa:</strong></div>
        <div class="border rounded p-2 bg-light">{{ selectedApprovalDetail.justification || '—' }}</div>
      </div>
      <ng-template #loadingApprovalDetailTpl>
        <div class="py-3 text-center text-muted">
          <i class="fas fa-spinner fa-spin me-2"></i>
          Carregando detalhes...
        </div>
      </ng-template>
      <div slot="footer" class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="closeViewModal()">Fechar</button>
      </div>
    </app-modal>

  </div>
</app-side-menu>
